const Quote = ()=>{
    return(
        <>Quote</>
    )
}
export default Quote;